package com.essntl.features.crm.data.supabase

import com.essntl.features.crm.domain.model.ContactOrganizationModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ContactOrganizationDto(
    val id: String,
    val name: String,
    val email: String? = null,
    @SerialName("organization_id")
    val organizationId: String? = null,
) {
    fun toModel() =
        ContactOrganizationModel(
            id = id,
            name = name,
            email = email,
            organizationId = organizationId,
        )
}